import { Button } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { getUserManagementService } from "../../backend";
import { Loader2, CheckCircle, XCircle, ArrowRight } from "lucide-react";
import MicroticaLogoColor from "../../assets/logo-color.svg";
import { Link } from "react-router-dom";
import AuthVisualPanel from "../../components/auth/AuthVisualPanel";

export default function EmailVerified() {
    const { email, code } = useParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');

    function handleLogin() {
        navigate("/auth/login");
    }

    useEffect(() => {
        async function loadData() {
            if (email && code) {
                try {
                    await getUserManagementService().activateUser({ username: email, code });
                    setStatus('success');
                } catch (error) {
                    setStatus('error');
                }
            }
        }
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="login-container">
            {/* Left side - Visual/Brand section */}
            <AuthVisualPanel />

            {/* Right side - Verification status */}
            <div className="login-form-section">
                <div className="login-form-wrapper">
                    {/* Mobile logo */}
                    <div className="login-mobile-brand">
                        <Link to="/">
                            <img src={MicroticaLogoColor} alt="Microtica" />
                        </Link>
                    </div>

                    {status === 'loading' && (
                        <div className="verify-status">
                            <div className="verify-status-icon verify-status-loading">
                                <Loader2 size={48} className="animate-spin" />
                            </div>
                            <h2 className="verify-status-title">Verifying your email</h2>
                            <p className="verify-status-text">
                                Please wait while we verify your email address...
                            </p>
                        </div>
                    )}

                    {status === 'success' && (
                        <div className="verify-status">
                            <div className="verify-status-icon verify-status-success">
                                <CheckCircle size={48} />
                            </div>
                            <h2 className="verify-status-title">Email verified!</h2>
                            <p className="verify-status-text">
                                Your email address has been verified successfully.
                                <br />
                                You can now sign in and start deploying.
                            </p>
                            <Button 
                                type="primary" 
                                size="large"
                                block
                                className="login-submit-btn"
                                onClick={handleLogin}
                            >
                                <span>Continue to sign in</span>
                                <ArrowRight size={18} className="login-submit-arrow" />
                            </Button>
                        </div>
                    )}

                    {status === 'error' && (
                        <div className="verify-status">
                            <div className="verify-status-icon verify-status-error">
                                <XCircle size={48} />
                            </div>
                            <h2 className="verify-status-title">Verification failed</h2>
                            <p className="verify-status-text">
                                We couldn't verify your email address. 
                                The link may have expired or is invalid.
                            </p>
                            <Button 
                                type="primary" 
                                size="large"
                                block
                                className="login-submit-btn"
                                onClick={handleLogin}
                            >
                                <span>Go to sign in</span>
                                <ArrowRight size={18} className="login-submit-arrow" />
                            </Button>
                            <div className="login-signup-link" style={{ marginTop: 24 }}>
                                Need a new verification link? <Link to="/auth/signup">Sign up again</Link>
                            </div>
                        </div>
                    )}
                </div>

                <div className="login-footer">
                    <span>© {new Date().getFullYear()} Microtica. All rights reserved.</span>
                </div>
            </div>
        </div>
    )
}
